import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/index',
            meta: { noRedirect: true } // 添加标记
        },
        {
            path: '/index',
            name: 'Index',
            component: () => import(/* webpackChunkName: "index" */ './views/index/Index.vue'),
            meta: {
                title: 'INDEX'
            }
        },
        {
            path: '/details',
            name: 'Details',
            component: () => import(/* webpackChunkName: "details" */ './views/details/Details.vue'),
            meta: {
                title: 'DETAILS'
            }
        },
        {
            path: '/collection',
            name: 'Collection',
            component: () => import(/* webpackChunkName: "collection" */ './views/collection/Collection.vue'),
            meta: {
                title: 'COLLECTION'
            }
        },
        {
            path: '/publish',
            name: 'Publish',
            component: () => import(/* webpackChunkName: "publish" */ './views/publish/Publish.vue'),
            meta: {
                title: 'PUBLISH'
            }
        },
        {
            path: '/launch',
            name: 'Launch',
            component: () => import(/* webpackChunkName: "launch" */ './views/launch/Launch.vue'),
            meta: {
                title: 'LAUNCH'
            }
        },
        {
            path: '/launchpad',
            name: 'LaunchPad',
            component: () => import(/* webpackChunkName: "launchpad" */ './views/launch/LaunchPad.vue'),
            meta: {
                title: 'LAUNCHPAD'
            }
        },
        {
            path: '/mint',
            name: 'Mint',
            component: () => import(/* webpackChunkName: "mint" */ './views/mint/Mint.vue'),
            meta: {
                title: 'MINT'
            }
        },
        {
            path: '/kline',
            name: 'Kline',
            component: () => import(/* webpackChunkName: "kline" */ './views/kline/Kline.vue'),
            meta: {
                title: 'KLINE'
            }
        },
        {
            path: '/delivery',
            name: 'Delivery',
            component: () => import(/* webpackChunkName: "delivery" */ './views/delivery/Delivery.vue'),
            meta: {
                title: 'DELIVERY'
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    console.log(`Navigating from ${from.path} to ${to.path}`);

    if (to.path === '' || to.path === '/') {
        return next('/index');
    }

    if (to.path === '/index') {
        if (to.query.inviterAddress) {
            sessionStorage.setItem('inviterAddress', to.query.inviterAddress);
        }
    }

    next();
});

const VueRouterPush = Router.prototype.push;

Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err);
}

export default router;
